import { css } from 'emotion';

import { colors, fonts } from '../../../../styles';

const popupBody = css`
  padding: 20px;
  display: flex;
  flex-direction: column;
  > span {
    font-size: ${fonts.size.small};
  }
`;

const radius = css`
  align-items: center;
  display: flex;
  color: ${colors.gray.dark};
  padding-top: 10px;
  > span {
    color: ${colors.gray.dark};
    font-size: 12px;
  }
  > svg {
    margin-right: 7px;
  }
`;

export default {
  popupBody,
  radius,
};
